export default "__VITE_ASSET__089ad372__"